import React, { useState, useEffect } from 'react';
import { Col, Select, Tag, Spin } from 'antd';
import { Form } from '@ant-design/compatible';
import { fetchApi } from 'Utils/utils';

const { Option } = Select;

const ColorListWithSuggestions = ({ getFieldDecorator, attr, productId, form }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadAttributeValues = async () => {
      if (!productId) return;
      setLoading(true);
      try {
        const response = await fetchApi.get(`/api/v1/product/${productId}/variant/attributeValues/color/`);
        setSuggestions(response || []);
      } catch (e) {
        console.error('Failed to load color suggestions:', e);
      } finally {
        setLoading(false);
      }
    };
    loadAttributeValues();
  }, [productId]);

  const handleTagClick = (value) => {
    const currentValues = form.getFieldValue(attr.code) || [];
    if (!currentValues.includes(value)) {
      form.setFieldsValue({ [attr.code]: [...currentValues, value] });
      setSuggestions((prev) => prev.filter((s) => s !== value));
    }
  };

  const handleDeselect = (value) => {
    if (!suggestions.includes(value)) {
      setSuggestions((prev) => [...prev, value]);
    }
  };

  return (
    <Col sm={24} md={12} key={attr.code}>
      <Form.Item label={attr.label}>
        {getFieldDecorator(attr.code, {
          rules: [{ required: attr.required, message: 'Select at least 1 color.' }]
        })(
          <Select mode="multiple" style={{ width: '100%' }} onDeselect={handleDeselect}>
            {attr.value.map((v, idx) => (
              <Option value={v} key={idx}>
                {v}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>
      {loading ? (
        <Spin size="small" style={{ marginLeft: 8 }} />
      ) : (
        suggestions.length > 0 && (
          <div style={{ marginTop: 8 }}>
            <span style={{ marginRight: 8 }}>Suggestions:</span>
            {suggestions.map((s, idx) => (
              <Tag
                key={idx}
                onClick={() => handleTagClick(s)}
                style={{ cursor: 'pointer', marginBottom: 4 }}
              >
                {s}
              </Tag>
            ))}
          </div>
        )
      )}
    </Col>
  );
};

export default ColorListWithSuggestions;
